module.exports = __webpack_public_path__ + "h5/img/ggu_logo.ab2fad60.png";